<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="8" :md="8">
            <a-button
              type="primary"
              icon="plus"
              size="small"
              @click="AddClick"
              v-if="isAdmin"
            >
              新增关键字
            </a-button>
          </a-col>

          <a-col
            :span="16"
            :md="16"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-input
              v-model="Query.skey"
              placeholder="模糊关键词"
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="margin-right: 10px"
              @click="SearchClieck()"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="12" :md="12">
            <a-button
              type="primary"
              icon="arrow-down"
              size="small"
              style="margin-right: 10px"
              @click="GrabBySearch()"
              v-show="false"
              v-if="isAdmin"
            >
              按照条件抓取
            </a-button>

            <a-button
              type="primary"
              icon="check"
              size="small"
              style="margin-right: 10px"
              @click="GrabAllKeys()"
              v-if="isAdmin"
            >
              全部抓取
            </a-button>

            <a-button
              type="danger"
              icon="delete"
              size="small"
              @click="DelAllKeys()"
              v-if="isAdmin"
            >
              清空任务
            </a-button>
          </a-col>
          <a-col
            :span="12"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-button
              type="primary"
              icon="area-chart"
              size="small"
              style="margin-right: 10px"
              @click="OpenSearchChart()"
            >
              按条件显示图表
            </a-button>
          </a-col>
        </a-row>

        <a-row type="flex" align="top" :gutter="16">
          <a-col :span="6" :lg="6" :md="24" :sm="24" :xs="24">
            <key-type-tree
              @checked="TreeChecked"
              @selected="TreeSelected"
            ></key-type-tree>
          </a-col>

          <a-col :span="18" :lg="18" :md="24" :sm="24" :xs="24">
            <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              size="small"
              :expandRowByClick="true"
            >
              <template slot="expandedRowRender" slot-scope="record">
                <div style="padding: 16px">
                  <p style="margin: 0 0 10px 0; font-weight: 600">所属类型：</p>
                  <div
                    class="tag-container"
                    :ref="`tagContainer-${record.id}`"
                    @scroll="handleTagScroll($event, record)"
                  >
                    <a-tag
                      v-for="(item, index) in getVisibleTags(record)"
                      :key="index"
                      color="#108ee9"
                    >
                      {{ item.keyType }}
                    </a-tag>
                    <div v-if="isLoadingMore(record)" class="loading-more">
                      <a-spin size="small" />
                    </div>
                  </div>
                </div>
              </template>
              <template slot="chart" slot-scope="row">
                <span class="icon" @click.stop="OpenKeywordChart(row)">
                  <svg
                    t="1763434425676"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4712"
                    width="32"
                    height="32"
                  >
                    <path
                      d="M85.504 938.688H1024V1024H0v-85.312h0.192V0h85.312v938.688zM128 723.328l212.736-271.552 303.424 155.52L990.912 256v632.64H128v-165.312z"
                      fill="#ffffff"
                      p-id="4713"
                    ></path>
                  </svg>
                </span>
              </template>
              <template slot="editBtn" slot-scope="row">
                <el-button
                  type="primary"
                  round
                  size="small"
                  icon="el-icon-edit"
                  style="margin-right: 5px"
                  @click.stop="EditClick(row)"
                  >编辑</el-button
                >
                <el-button
                  type="info"
                  round
                  size="small"
                  icon="el-icon-link"
                  style="margin-right: 5px"
                  @click.stop="BuildClick(row)"
                  >关联</el-button
                >

                <el-button
                  type="warning"
                  round
                  size="small"
                  icon="el-icon-share"
                  style="margin-right: 5px"
                  @click.stop="GrabSingle(row)"
                  >抓取</el-button
                >

                <el-button
                  type="danger"
                  round
                  size="small"
                  icon="el-icon-delete"
                  style="margin-right: 5px"
                  @click.stop="DelClick(row)"
                  >删除</el-button
                >
              </template>
            </a-table>
            <div class="PageCom">
              <el-pagination
                background
                :current-page="Page.index"
                :page-sizes="Page.sizes"
                :page-size="Page.size"
                :total="Page.total"
                layout="sizes, total, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
  </div>
</template>

<script>
import { getKeywordList, keywordDel } from "@/api/keyword";
import { grabGpInfoByIds, delAllTask } from "@/api/grab";
import KeyTypeTree from "@/components/Tree/KeyTypeTree.vue";
import store from "@/store";
export default {
  components: {
    KeyTypeTree,
  },
  data() {
    return {
      Query: {
        skey: "",
        parIds: [],
      },
      columns: [
        {
          title: "关键字",
          dataIndex: "keyword",
          key: "keyword",
        },
        {
          title: "添加人",
          dataIndex: "addUserName",
          key: "addUserName",
        },
        {
          title: "更新时间",
          dataIndex: "lastUpdateTime",
          key: "lastUpdateTime",
        },
        {
          title: "数据",
          key: "chart",
          scopedSlots: { customRender: "chart" },
        },
      ],
      tableData: [],
      visibleTagCounts: {},
      loadingStates: {},
      batchSize: 40,
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      expandableConfig: {
        rowExpandable: (record) => {
          return record;
        },
      },
      isAdmin: store.getters.roles.includes("admin"),
    };
  },
  created() {
    this.GetTableData();
    if (this.isAdmin) {
      this.columns.push({
        title: "操作",
        key: "editBtn",
        scopedSlots: { customRender: "editBtn" },
      });
    }
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData(this.Query);
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetTableData(this.Query);
    },
    GetTableData() {
      getKeywordList(
        this.Query.skey,
        this.Query.parIds,
        this.Page.index,
        this.Page.size
      ).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.Page.total = res.data.total;
        }
      });
    },
    SearchClieck() {
      this.Page.index = 1;
      this.GetTableData();
    },
    AddClick() {
      this.$emit("addClick");
    },
    EditClick(row) {
      this.$emit("editClick", row);
    },
    BuildClick(row) {
      this.$emit("buildClick", row);
    },
    DelClick(row) {
      this.$confirm("此操作将永久删除此关键字, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          keywordDel(row.id).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.GetTableData();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    GrabSingle(row) {
      grabGpInfoByIds([row.id]).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    GrabBySearch() {
      console.log("GrabBySearch");
    },
    GrabAllKeys() {
      grabGpInfoByIds([]).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    DelAllKeys() {
      this.$confirm("此操作将清空所有任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delAllTask().then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    TreeChecked(keys, info) {
      this.Query.parIds = keys;
    },

    TreeSelected(keys) {
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${keys}`;
        const fullUrl = baseUrl + "#/keytype-chart" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/keytype-chart",
          query: { id: keys },
        });
      }
    },
    // 修改getVisibleTags方法，确保它返回正确数量的标签
    getVisibleTags(record) {
      if (!record || !record.keyTypeList) return [];

      // 获取当前应该显示的标签数量
      const visibleCount = this.visibleTagCounts[record.id] || this.batchSize;

      // 确保不会超出实际数据长度
      const actualCount = Math.min(visibleCount, record.keyTypeList.length);

      console.log(
        `For record ${record.id}, showing ${actualCount} of ${record.keyTypeList.length} tags`
      );

      return record.keyTypeList.slice(0, actualCount);
    },

    // 检查是否正在加载更多
    isLoadingMore(record) {
      if (!record.keyTypeList) return false;
      const visibleCount = this.visibleTagCounts[record.id] || this.batchSize;
      return (
        visibleCount < record.keyTypeList.length &&
        this.loadingStates[record.id]
      );
    },

    // 处理滚动事件 - 改进版
    handleTagScroll(event, record) {
      const container = event.target;

      // 调试信息，帮助确认滚动状态
      console.log("Scroll event detected:", {
        scrollHeight: container.scrollHeight,
        scrollTop: container.scrollTop,
        clientHeight: container.clientHeight,
        difference:
          container.scrollHeight - container.scrollTop - container.clientHeight,
      });

      // 增加更宽松的检测条件，确保能够触发加载
      // 当距离底部20px内时触发加载
      const isNearBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight <
        20;

      // 只有当容器可以滚动且接近底部时才加载更多
      const canScroll = container.scrollHeight > container.clientHeight;

      if (canScroll && isNearBottom) {
        this.loadMoreTags(record);
      }
    },

    // 修改loadMoreTags方法，确保响应式更新
    loadMoreTags(record) {
      if (!record.keyTypeList || this.loadingStates[record.id]) {
        console.log("Load more skipped:", {
          hasKeyTypeList: !!record.keyTypeList,
          isLoading: !!this.loadingStates[record.id],
        });
        return;
      }

      const currentCount = this.visibleTagCounts[record.id] || this.batchSize;

      // 检查是否还有更多数据可加载
      if (currentCount >= record.keyTypeList.length) {
        console.log("No more tags to load");
        return;
      }

      console.log(
        "Loading more tags for record:",
        record.id,
        "from count:",
        currentCount
      );

      // 设置加载状态
      this.loadingStates[record.id] = true;

      // 模拟异步加载
      setTimeout(() => {
        // 使用Vue的set方法确保响应式更新
        this.$set(
          this.visibleTagCounts,
          record.id,
          currentCount + this.batchSize
        );
        this.loadingStates[record.id] = false;
        console.log("Tags loaded, new count:", currentCount + this.batchSize);
      }, 300);
    },

    OpenKeywordChart(row) {
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${row.id}`;
        const fullUrl = baseUrl + "#/keyword-chart" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/keyword-chart",
          query: { id: row.id },
        });
      }
    },
    OpenSearchChart() {
      if (this.Query.parIds.length > 0 || this.Query.skey != "") {
        try {
          // 使用Vue Router的resolve方法构建完整URL用于新窗口打开
          const queryObject = this.Query; // 确保使用正确的变量名
          const routeData = this.$router.resolve({
            path: "/keyword-search-chart",
            query: {
              ...queryObject,
              t: new Date().getTime(), // 添加时间戳防缓存
            },
          });
          console.log(
            "使用Vue Router的resolve方法构建的完整URL:",
            routeData.href
          );
          // 在新标签页中打开
          const newWindow = window.open(routeData.href, "_blank");
        } catch (error) {
          console.error("跳转错误:", error);
          // 备选方案2: 如果所有方法都失败，提示用户
          this.$message.error("无法打开图表页面，请稍后重试");
        }
      } else {
        console.log(this.Query);
        return this.$message.warning("请输入搜索条件");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 可以添加一些样式来美化展开行
:deep(.ant-table-expanded-row) {
  background-color: #fafafa;
  border-top: 1px solid #f0f0f0;
}

// ... existing code ...
.tag-container {
  max-height: 100px;
  min-height: 22px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  // 确保在所有浏览器中都能正常显示滚动条
  -ms-overflow-style: auto;
  scrollbar-width: thin;
  // 确保容器样式不会影响滚动事件
  position: relative;
}

// 针对Webkit内核浏览器（Chrome、Safari等）的滚动条样式
.tag-container::-webkit-scrollbar {
  width: 6px; // 滚动条宽度
}

.tag-container::-webkit-scrollbar-track {
  background: #f1f1f1; // 滚动条轨道背景
  border-radius: 3px;
}

.tag-container::-webkit-scrollbar-thumb {
  background: #888; // 滚动条滑块颜色
  border-radius: 3px;
}

.tag-container::-webkit-scrollbar-thumb:hover {
  background: #555; // 滚动条滑块悬停颜色
}

.loading-more {
  width: 100%;
  text-align: center;
  padding: 10px 0;
}

// 自定义滚动条样式
.tag-container::-webkit-scrollbar {
  width: 6px;
}

.tag-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.tag-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.tag-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #1296db;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin: 7px;
  vertical-align: middle;
  cursor: pointer;
}
</style>